import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TabsComponent} from './tabs/tabs.component';
import {WidgetsComponent} from './widgets/widgets.component';
import {RouterModule} from '@angular/router';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {WidgetModule} from '@components/widget/widget.module';
import { KpisComponent } from './kpis/kpis.component';
import {KpiModule} from '@components/kpi/kpi.module';
import {MatExpansionModule} from '@angular/material/expansion';
import {JoyrideModule} from 'ngx-joyride';

@NgModule({
    declarations: [
        TabsComponent,
        WidgetsComponent,
        KpisComponent,
    ],
    exports: [
        TabsComponent,
        WidgetsComponent,
        KpisComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        DragDropModule,
        WidgetModule,
        KpiModule,
        MatExpansionModule,
        JoyrideModule,
    ]
})
export class AdModule {
}
